// extracted by mini-css-extract-plugin
export default {"forgotPWLink":"_82830d55","forgotPwLink":"_82830d55"};